import React from "react";
import { Box, Typography } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  blueBox: {
    position: "absolute",
    color: "#fff",
    zIndex: 100,
    height: 130,
    borderRadius: "0 0 0 70px",
    background:
      "linear-gradient(0deg, rgba(125,204,230,1) 0%, rgba(87,166,219,1) 100%, rgba(125,204,230,1) 0%)",
  },
  content: {
    fontWeight: 300,
    paddingTop: "0px",
    paddingLeft: 70,
  },
});

const BlueBox = ({ classes, text, boxStyle, contentStyle }) => {
  return (
    <Box
      className={boxStyle ? boxStyle : classes.blueBox}
      width="100%"
      display="flex"    
      alignItems="center"
    >
      <Typography variant="h1" color="inherit" className={contentStyle ? contentStyle : classes.content}>
        <Box dangerouslySetInnerHTML={{ __html: text }} />
      </Typography>
    </Box>
  );
};

export default withStyles(styles)(BlueBox);
